import React, { ComponentProps, FunctionComponent } from "react";

const CoachIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 16",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M12.8249 11.2518C11.5569 9.53682 9.97659 9.13971 9.14206 8.87804V8.27205C9.725 7.70193 10.053 6.92373 10.053 6.11219V2.88661C10.0511 1.71637 9.09331 0.767832 7.91163 0.766663H6.05876C4.87705 0.768619 3.91989 1.71642 3.91803 2.88661V6.11219C3.91803 6.91128 4.23618 7.67773 4.80333 8.24583V8.89552C4.0254 9.13883 2.44255 9.53673 1.17447 11.2516C0.409052 12.2829 -0.00263476 13.5295 1.26892e-05 14.8093C1.26892e-05 14.9222 0.0448035 15.0298 0.125166 15.1094C0.205527 15.189 0.314872 15.2333 0.428173 15.2333H13.5718C13.8083 15.2333 14 15.0435 14 14.8093C14.0026 13.5295 13.5909 12.2823 12.8249 11.2516L12.8249 11.2518ZM8.28644 9.06524L7.05335 10.9753C7.00527 10.972 6.95718 10.9727 6.90844 10.9759L5.65888 9.08025V8.85324C6.48819 9.24854 7.45324 9.2531 8.28643 8.86564L8.28644 9.06524ZM5.06937 5.06665C4.72092 3.96229 4.78284 4.15734 4.77427 4.13059L4.77493 3.97599H9.19684V4.12602C9.18762 4.15342 9.25283 3.95382 8.88858 5.06664C6.82745 4.76658 7.15934 4.76203 5.06937 5.06665ZM4.77493 2.88659C4.77559 2.18471 5.34998 1.61589 6.05874 1.61459H7.91162C8.62103 1.61589 9.19608 2.18471 9.19674 2.88659V3.12859H4.77483L4.77493 2.88659ZM4.77427 5.88206L4.77493 5.88272C4.85134 5.91011 4.93236 5.92512 5.01339 5.92707C5.05818 5.92707 4.95937 5.93947 6.37163 5.73333C7.11991 5.6244 7.527 5.72485 8.88063 5.92185L8.88129 5.9225C8.98866 5.93228 9.09668 5.91728 9.19681 5.87749V6.11231C9.19747 6.69352 8.96495 7.25124 8.55063 7.66285C8.13566 8.0738 7.57246 8.30538 6.98557 8.30538C6.39866 8.30538 5.83614 8.07382 5.42116 7.66285C5.00619 7.25125 4.77367 6.69352 4.77498 6.11231V5.88205L4.77427 5.88206ZM5.04961 9.70715L6.14831 11.3731V11.3738C5.86969 11.7228 5.8407 12.2068 6.0752 12.5864C6.30969 12.9654 6.75893 13.1598 7.19961 13.0717V13.4709C7.19961 13.7051 7.39063 13.895 7.62711 13.895C7.86359 13.895 8.05527 13.7051 8.05527 13.4709V12.0333C8.05527 11.7906 7.97096 11.5551 7.81682 11.3666L8.89841 9.69152C9.52483 9.88721 9.85748 9.97462 10.3482 10.2277V14.3854L3.65253 14.3861V10.2277C4.1426 9.97395 4.48316 9.88458 5.0503 9.70715L5.04961 9.70715ZM2.79624 10.7815V14.3862H0.873553C0.986191 12.9733 1.68178 11.6692 2.79624 10.7815ZM11.2032 14.3862L11.2038 10.7815C12.3183 11.6693 13.0139 12.9732 13.1265 14.3862H11.2032Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
    })
  );
};

const ForwardRef = React.forwardRef(CoachIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
